import { render } from "./DeviceInfo.vue?vue&type=template&id=8b34e2e8&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"

import "./DeviceInfo.vue?vue&type=style&index=0&id=8b34e2e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b34e2e8"]])

export default __exports__